/**
 * Tiny scroll-progress hook.
 * Returns 0..1 across a container element so we can drive
 * the cinematic without pulling in framer-motion / gsap.
 */
import { useEffect, useState } from "react";

export const useScrollProgress = (ref) => {
  const [p, setP] = useState(0);
  useEffect(() => {
    if (!ref.current) return;
    let raf = 0;
    const onScroll = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const el = ref.current;
        if (!el) return;
        const r = el.getBoundingClientRect();
        const total = r.height - window.innerHeight;
        const passed = Math.min(Math.max(-r.top, 0), total);
        setP(total > 0 ? passed / total : 0);
      });
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      cancelAnimationFrame(raf);
    };
  }, [ref]);
  return p;
};

// 4 beats spread over [0, 1]
// 0.00 – 0.22  Chaos
// 0.22 – 0.50  Focus
// 0.50 – 0.82  Tree
// 0.82 – 1.00  Panel
export const beat = (p) => {
  if (p < 0.22) return 0;
  if (p < 0.5) return 1;
  if (p < 0.82) return 2;
  return 3;
};

export const sub = (p, lo, hi) => {
  const t = (p - lo) / (hi - lo);
  return Math.min(Math.max(t, 0), 1);
};

export const ease = (t) => t * t * (3 - 2 * t); // smoothstep
